import { defineStore } from "pinia";
import { LLMCasesMap } from "@/models";
import { getAllCasesPaged } from "@/api/cases";
import { groupItemsByDate, mergeLLMCasesByDate } from "@/utils/timeUtils";
import { FilterDateRange } from "@/utils/time/TimeDateConverter";

const PAGE_SIZE = 50;

export type LLMCaseListFilter = {
  name?: string;
  dateCreated?: FilterDateRange;
  fromDate?: string;
  toDate?: string;
};

const buildParams = (page: number, size: number, filter: LLMCaseListFilter): URLSearchParams => {
  const params = new URLSearchParams();
  params.append("size", size.toString());
  params.append("page", page.toString());
  if (filter.name) params.append("title", filter.name);
  if (filter.dateCreated) {
    params.append("dateCreated", filter.dateCreated);
  } else if (filter.fromDate && filter.toDate) {
    params.append("fromDate", filter.fromDate);
    params.append("toDate", filter.toDate);
  }
  return params;
};

export const useLLMCaseListStore = defineStore("llmCaseList", {
  state: () => ({
    cases: {} as LLMCasesMap,
    pagination: {
      total: 0,
      current: 1,
      size: PAGE_SIZE,
    },
    lastFilter: {} as LLMCaseListFilter,
  }),
  actions: {
    async updateCaseList(filter: LLMCaseListFilter = {}) {
      this.lastFilter = filter;
      this.pagination.current = 1;
      const params = buildParams(this.pagination.current, this.pagination.size, filter);
      const caseList = await getAllCasesPaged(params, "llm");
      this.pagination.current = caseList.number + 1;
      this.pagination.total = caseList.totalPages;
      this.cases = groupItemsByDate(caseList.content);
    },
    async loadMoreCases() {
      this.pagination.current += 1;
      const params = buildParams(this.pagination.current, this.pagination.size, this.lastFilter);
      const caseList = await getAllCasesPaged(params, "llm");
      this.pagination.current = caseList.number + 1;
      this.pagination.total = caseList.totalPages;
      this.cases = mergeLLMCasesByDate(this.cases, groupItemsByDate(caseList.content));
    },
  },
});
